<template>
	<div id="app" :class="environment">
		<div class="main-wrapper">
			<header id="header">
				<div class="inner">

					<div v-if="host === 'experiencebuilder'" class="logo" target="_blank" style="background-image: url('/assets/images/logo_bylt.svg');"></div>
					<div v-else class="logo" target="_blank" style="background-image: url('/assets/images/360logo.svg');"></div>

					<nav v-if="auth">
						<ul>
							<li v-if="roles['Admin'] || user.privileges.pages.preview">
								<router-link to="/preview">Live preview</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.dashboard">
								<router-link to="/dashboard">Dashboard</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.content">
								<router-link to="/content">Content</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.submissions">
								<router-link to="/submissions">Submissions</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.trees">
								<router-link to="/trees">Trees</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.pages">
								<router-link to="/pages">Pages</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.settings">
								<router-link to="/settings">Settings</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.references">
								<router-link to="/references">References</router-link>
							</li>
							<!-- <li v-if="roles['Admin'] || user.privileges.pages.seo">
								<router-link to="/seo">SEO</router-link>
							</li> -->
							<li v-if="roles['Admin'] || user.privileges.pages.showpad">
								<router-link to="/showpad">Showpad</router-link>
							</li>
							<li v-if="roles['Admin'] || user.privileges.pages.users">
								<router-link to="/users">Users</router-link>
							</li>
							<li>
								<a href="#" v-on:click="logoutClickHandler">Logout</a>
							</li>
							<!-- <li><router-link to="/hosting">Hosting</router-link></li> -->
							<!-- <li><router-link to="/docs">Docs</router-link></li> -->
							<li>
								<span>{{user.username}}</span>
								<ProjectSwitch/>
							</li>
						</ul>
					</nav>

					<!-- <a href="#" id="openMobileNav">open</a> -->
				</div>
			</header>

			<section id="main">
				<router-view/>
			</section>

			<div class="buttonbar">
				<!-- <a href="pages/translation-sidebar.php" class="btn-translations-open fa fa-comment" data-routing-target="#sidebar"></a> -->
				<button v-if="roles['Admin']" class="btn-code-open fa fa-code" @click="btnCodebarClickHandler"></button>
			</div>
		</div>

		<div class="bubble bubble-user-switch">
			<p>Switch to this user login. This wil terminate your current session.</p>
			<a href="" class="btn green btn-delete">Confirm</a> <a href="" class="btn black btn-cancel">Cancel</a>
		</div>

		<Codebar v-if="roles['Admin']" ref="Codebar"></Codebar>
		<div class="saveAnimation"></div>

		<script v-if="freshdeskid" type="application/javascript">
			!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
		</script>
		<script v-if="freshdeskid" type='application/javascript' v-bind:src="'https://euc-widget.freshworks.com/widgets/' + freshdeskid + '.js'" async defer></script>
	</div>
</template>

<script>

import Codebar from './components/Codebar.vue'
import ProjectSwitch from './components/ProjectSwitch.vue'
import cms from './modules/cms.js'

export default {
	name: 'app',
	components: {
		'Codebar': Codebar,
		'ProjectSwitch': ProjectSwitch
	},
	data () {
		return {
			auth: this.$store.state.auth,
			roles: this.$store.state.user.roles,
			user: this.$store.state.user,
			widgetPrefilled: false,
			host: window.location.host.split('.')[1],
			freshdeskid: this.$store.state.freshdeskid,
			environment: process.env.VUE_APP_ENVIRONMENT
		}
	},

	updated () {
		this.auth = this.$store.state.auth
		this.roles = this.$store.state.user ? this.$store.state.user.roles : null
		this.user = this.$store.state.user
	},

	mounted () {
		window.fwSettings = {
			'widget_id': this.freshdeskid
		}
		cms.init()
	},

	watch: {
		$route (to, from) {
			if (to.name === 'login') {
				if (window.FreshworksWidget) window.FreshworksWidget('hide')
				this.widgetPrefilled = false
			} else {
				if (window.FreshworksWidget) {
					if (!this.widgetPrefilled) {
						window.FreshworksWidget('prefill', 'ticketForm', {
							email: this.user.username,
							custom_fields: {
								cf_market: 'global'
							}
						})

						// now disable those fields to prevent the user from changing them
						window.FreshworksWidget('disable', 'ticketForm', ['email', 'custom_fields.cf_market'])
						this.widgetPrefilled = true
					}

					window.FreshworksWidget('show')
				}
			}
		}
	},

	methods: {
		logoutClickHandler (e) {
			e.preventDefault()

			// log out
			this.$store.dispatch('logout').then(() => {
				this.$router.push({ path: '/login' }, onComplete => {}, onAbort => { })
				this.widgetPrefilled = false
			}).catch(err => {
				console.error(err)
			})
		},

		btnCodebarClickHandler (e) {
			e.preventDefault()

			this.$refs.Codebar.toggle()
		}
	}
}
</script>

<style lang="scss">
	@import 'src/_scss/screen.scss';
</style>

<style>
	iframe#launcher-frame, iframe#widget-frame {
		position: relative;
		left: auto;
		top: auto;
	}
</style>
